<script setup lang="ts">
const { setSeoMeta, getBreadcrumbSchema } = useSeo()

setSeoMeta({
  title: 'Kortingen - Promoties & Aanbiedingen',
  description: 'Ontdek beschikbare kortingen en promoties voor kinderkampen bij \'t SpeelFabrik. Bespaar op zomerkampen, dagtochten en activiteiten voor kinderen.',
  image: '/images/og-default.jpg',
  keywords: ['kortingen kinderkampen', 'promoties zomerkampen', 'aanbiedingen kinderactiviteiten', 'korting kampen'],
})

// Branded OG image
defineOgImage('SpeelFabrik', {
  title: 'Kortingen',
  description: 'Ontdek beschikbare kortingen en promoties voor kinderkampen.',
})

useSchemaOrg([
  getBreadcrumbSchema([
    { name: 'Home', path: '/' },
    { name: 'Kortingen', path: '/kortingen' },
  ]),
])

definePageMeta({
  layout: 'front-page',
  public: true,
  pageTitle: {
    title: 'Kortingen',
    subtitle: 'Ontdek onze beschikbare kortingen en promoties',
    icon: 'bx-purchase-tag',
    iconColor: 'primary',
  },
})
</script>

<template>
  <VContainer>
    <VRow>
      <VCol cols="12">
        <VCard>
          <VCardText class="text-center pa-8">
            <VIcon
              icon="bx-purchase-tag"
              size="64"
              color="warning"
              class="mb-4"
            />
            <h2 class="text-h4 mb-4">
              Kortingen
            </h2>
            <p class="text-body-1 text-medium-emphasis">
              Deze pagina is momenteel in ontwikkeling.
            </p>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>
